var win = window;

export var caf = win.cancelAnimationFrame
  || win.mozCancelAnimationFrame
  || function(id){ clearTimeout(id); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/caf.js
// module id = 66
// module chunks = 0